import { useState } from 'react';
import { StyledChip } from './ToggleChip.styles';
import type { ToggleChipProps } from './ToggleChip.types';

const ToggleChip = ({
  label,
  defaultValue,
  value,
  onClick,
  disabled,
  readonly
}: ToggleChipProps) => {
  'use memo';
  const [active, setActive] = useState(defaultValue);

  const toggle = () => {
    setActive(!active);
    onClick(!active);
  };

  return (
    <StyledChip
      disabled={disabled}
      label={label}
      readonly={readonly}
      variant={active || value ? 'filled' : 'outlined'}
      onClick={toggle}
    />
  );
};

export default ToggleChip;
